"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFIX = exports.MessageContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var Components = _interopRequireWildcard(require("../../index"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _scrollToBottom = require("../../utils/scrollToBottom");
var _context = require("../ConfigProvider/context");
var _excluded = ["type", "from", "data", "withBubble"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('message-container');
exports.PREFIX = PREFIX;
var MessageContainer = function MessageContainer(props) {
  var className = props.className,
    messages = props.messages;
  var _useContext = (0, _react.useContext)(_context.ConfigContext),
    rootId = _useContext.rootId;
  (0, _react.useEffect)(function () {
    rootId && (0, _scrollToBottom.scrollToBottom)(rootId);
  }, [messages]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(PREFIX, className),
    id: PREFIX
  }, messages.map(function (message, index) {
    var type = message.type,
      from = message.from,
      data = message.data,
      _message$withBubble = message.withBubble,
      withBubble = _message$withBubble === void 0 ? true : _message$withBubble,
      rest = (0, _objectWithoutProperties2.default)(message, _excluded);
    var Component = Components[type];
    return withBubble ? /*#__PURE__*/_react.default.createElement(Components.Bubble, (0, _extends2.default)({
      key: index,
      from: from
    }, rest), Component ? /*#__PURE__*/_react.default.createElement(Component, data) : /*#__PURE__*/_react.default.createElement(Components.UnsupportedMessage, null)) : Component ? /*#__PURE__*/_react.default.createElement(Component, data) : /*#__PURE__*/_react.default.createElement(Components.UnsupportedMessage, null);
  }));
};
exports.MessageContainer = MessageContainer;